import { useEffect, useState } from "react";
import axios from "../../../axios";
import * as styled from "./TeachersMark.styled";
import TopPageTitle from "../../../components/TopPageTitle/TopPageTitle";


function TeachersMark() {
  const [lessons, setLessons] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [skip, setSkip] = useState(0);
  const limit = 10;
  const [students, setStudents] = useState([]);
  const [teachers, setTeachers] = useState([]);

  const [filters, setFilters] = useState({
    studentId: "",
    teacherId: "",
    date: "",
    startDate: "",
    endDate: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // ===== Загрузка всех уроков по умолчанию =====
  useEffect(() => {
    fetchLessons(true);
    fetchTeachersAndStudents();
  }, []);

  const fetchLessons = async (initial = false, filterUrl = "") => {
  setLoading(true);
  setError("");

  try {
    const base =
      filterUrl ||
      `/marked-lessons?limit=${limit}&skip=${initial ? 0 : skip}`;
    const response = await axios.get(base);

    let newLessons = [];
    let total = 0;

    if (Array.isArray(response.data)) {
      // фильтр по teacherId или другим params
      newLessons = response.data;
      total = response.data.length;
    } else {
      // обычный запрос с пагинацией
      newLessons = response.data.lessons;
      total = response.data.total;
    }

    if (initial) {
      setLessons(newLessons);
      setSkip(newLessons.length);
    } else {
      setLessons((prev) => [...prev, ...newLessons]);
      setSkip((prev) => prev + newLessons.length);
    }

    if (skip + newLessons.length >= total) {
      setHasMore(false);
    }
  } catch (err) {
    console.error(err);
    setError("Ошибка при загрузке уроков");
  } finally {
    setLoading(false);
  }
};


  const fetchTeachersAndStudents = async () => {
    try {
      const [teachersRes, studentsRes] = await Promise.all([
        axios.get("/teachers"),
        axios.get("/students"),
      ]);
      setTeachers(teachersRes.data);
      setStudents(studentsRes.data);
    } catch (err) {
      console.log("Ошибка при получении учителей/Ученьов", err);
    }
  };

  // ===== Обработка фильтров =====
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleReset = () => {
    setFilters({
      studentId: "",
      teacherId: "",
      date: "",
      startDate: "",
      endDate: "",
    });
    fetchLessons(true); // сброс с начальными данными
  };

  const handleSearch = async (e) => {
    e.preventDefault();

    let url = "";
    const query = [];

   if (filters.date) {
  query.push(`date=${filters.date}`);
} else if (filters.startDate && filters.endDate) {
  query.push(`startDate=${filters.startDate}`);
  query.push(`endDate=${filters.endDate}`);
}

if (query.length > 0) {
  url = `/marked-lessons/by-date?${query.join("&")}`;
} else if (filters.studentId) {
  url = `/marked-lessons/student/${filters.studentId}`;
} else if (filters.teacherId) {
  url = `/marked-lessons/teacher/${filters.teacherId}`;
}


    await fetchLessons(true, url);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Удалить эту запись?")) return;

    try {
      await axios.delete(`/marked-lessons/${id}`);
      setLessons((prev) => prev.filter((lesson) => lesson._id !== id));
    } catch (err) {
      alert("Ошибка при удалении записи");
    }
  };
  return (
    <styled.Wrapper>
      <TopPageTitle value={'Відмітки про уроки'}/>
      <styled.FilterBox onSubmit={handleSearch}>
        <div>
          <styled.Label>Учень:</styled.Label>
          <styled.Select
            name="studentId"
            value={filters.studentId}
            onChange={handleChange}
          >
            <option value="">-- Вибрати учня --</option>
            {students.map((student) => (
              <option key={student.studentId} value={student._id}>
                {student.name} ({student.studentId})
              </option>
            ))}
          </styled.Select>
        </div>

        <div>
          <styled.Label>Вчитель:</styled.Label>
          <styled.Select
            name="teacherId"
            value={filters.teacherId}
            onChange={handleChange}
          >
            <option value="">--Вибрати вчителя --</option>
            {teachers.map((teacher) => (
              <option key={teacher.teacherId} value={teacher._id}>
                {teacher.name} ({teacher.teacherId})
              </option>
            ))}
          </styled.Select>
        </div>

        {/* <div>
          <styled.Label>Дата:</styled.Label>
          <styled.Input
            name="date"
            type="date"
            value={filters.date}
            onChange={handleChange}
          />
        </div>

        <div>
          <styled.Label>С:</styled.Label>
          <styled.Input
            name="startDate"
            type="date"
            value={filters.startDate}
            onChange={handleChange}
          />
        </div>

        <div>
          <styled.Label>По:</styled.Label>
          <styled.Input
            name="endDate"
            type="date"
            value={filters.endDate}
            onChange={handleChange}
          />
        </div> */}

        <styled.Button type="submit">Знайти</styled.Button>
        <styled.Button type="button" onClick={handleReset} $secondary>
          Скинути
        </styled.Button>
      </styled.FilterBox>

      {loading && <styled.Message>Загрузка...</styled.Message>}
      {error && <styled.Message>{error}</styled.Message>}

      {!loading && lessons?.length > 0 && (
        <styled.Table>
          <thead>
            <tr>
              <th>Учень</th>
              <th>Вчитель</th>
              <th>Дата</th>
              <th>Коментар</th>
            </tr>
          </thead>
          <tbody>
            {lessons.map((lesson) => (
              <tr key={lesson._id}>
                <td>{lesson.studentName}</td>
                <td>{lesson.teacherName}</td>
                <td>{new Date(lesson.createdAt).toLocaleString()}</td>
                <td>{lesson.comment || "—"}</td>
                <td>
                  <styled.DeleteButton onClick={() => handleDelete(lesson._id)}>
                    🗑 Видалити
                  </styled.DeleteButton>
                </td>
              </tr>
            ))}
          </tbody>
        </styled.Table>
      )}

      {!loading && lessons.length === 0 && (
        <styled.Message>Немає результатів</styled.Message>
      )}
      {!loading && hasMore && (
        <styled.Button onClick={() => fetchLessons(false)} $secondary>
          Загрузити ще
        </styled.Button>
      )}
    </styled.Wrapper>
  );
}

export default TeachersMark;
